module.exports = __webpack_public_path__ + "./EricaPhoto_8263530508dc8d04b3c4c00460878ccd.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/EricaPhoto.png
// module id = 493
// module chunks = 0